import Vue from 'vue'
import VueI18n from 'vue-i18n'
import MessageFormat from 'messageformat'
// import moment from 'moment'
import price from './i18n-formaters/price'

Vue.use(VueI18n)

class MessageFormatter {
  constructor (options) {
    this._locale = options.locale || 'en-US'
    this._formatter = new MessageFormat(this._locale)
    this._caches = Object.create(null)

    this._formatter.addFormatters({
      // momentAgo (value) { return moment(value).fromNow() }
      price
    })
  }

  interpolate (message, values) {
    let fn = this._caches[message]
    if (!fn) {
      fn = this._formatter.compile(message, this._locale)
      this._caches[message] = fn
    }
    return [fn(values)]
  }
}

const locale = 'de-DE'
const formatter = new MessageFormatter({ locale })

const i18n = new VueI18n({
  locale,
  formatter,
  messages: {
    'de-DE': require('static/locales/de-DE.json')
  }
})

export default i18n



// WEBPACK FOOTER //
// ./client/plugins/vue-i18n.js